'use client'

import { envService } from '@/core/services/env'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import React from 'react'

const PAYMENT_PUBLIC_KEY = envService.get('STRIPE_KEY')
const stripePromise = loadStripe(PAYMENT_PUBLIC_KEY)

interface Props {
  children: React.ReactNode
  clientSecret?: string
}

export const StripeProvider: React.FC<Props> = ({ children, clientSecret }) => {
  if (!clientSecret) return null

  return (
    <Elements
      stripe={stripePromise}
      options={{
        clientSecret,
        appearance: {
          theme: 'stripe',
          variables: {
            colorPrimary: '#083358',
            colorBackground: '#FFFFFF',
            colorText: '#083358',
            colorDanger: '#FC3C3C',
            colorWarning: '#FFAF00',
            colorSuccess: '#26992B',
            colorTextSecondary: '#A3A5A5',
            colorTextPlaceholder: '#A3A5A5',
            colorIcon: '#A3A5A5',
            colorIconHover: '#083358',
            spacingUnit: '4px',
            fontSizeBase: '16px',
            borderRadius: '0.375rem',
            spacingGridRow: '1rem',
            spacingGridColumn: '0.75rem',
            focusBoxShadow: 'none',
            focusOutline: '2px solid #DBDDDD',
          },
        },
      }}
    >
      {children}
    </Elements>
  )
}
